<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">Is this visit related to a workplace event?</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col">
                <multiselect-list :options="options" @optionSelected="optionSelected"></multiselect-list>
            </div>
            <div class="col-md-1"></div>
        </div>
        <div class="row">
            <div class="col text-center mt-2">
                <button type="button" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
            </div>
        </div>
    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import MultiselectList from '../../components/MultiselectList'
  import AnalyticsMixin from '../../mixins/AnalyticsMixin'

  export default {
    name: 'Blocker',

    components: { MultiselectList },

    mixins: [ErrorsMixin, OptionsMixin, AnalyticsMixin],

    data () {
      return {
        isWorkersComp: null,
        selectedId: null,
        isSaving: false
      }
    },

    computed: {
      options () {
        return [
          {
            id: 1,
            name: 'Yes',
            value: true,
            selected: this.isWorkersComp === true
          },
          {
            id: 2,
            name: 'No',
            value: false,
            selected: this.isWorkersComp === false
          }
        ]
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (this.isWorkersComp === null) {
          this.addErrorForField('exception', 'You must select yes or no to continue.')
        }
        return !this.hasErrors()
      },

      loadData () {

      },

      optionSelected (item) {
        this.clearAllErrors()

        this.isWorkersComp = item.value
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.isSaving = true
        api.put('/Patient/WorkersCompPrompt/' + this.isWorkersComp).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)

          this.$store.setModuleStatus('WorkersCompPrompt', true, () => {
            if (response.data.isBlocked) {
              this.$router.push('/workers-comp-block')
            } else {
              this.$router.push(this.$store.nextRoute())
            }
            this.isSaving = false
          })
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        })

      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
